import { render } from "./SingleFeesComponent.vue?vue&type=template&id=53ed3b78"
import script from "./SingleFeesComponent.vue?vue&type=script&lang=js"
export * from "./SingleFeesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twilkinson/Desktop/af3-shortcodes-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__